import React, { useState, useEffect, useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectCoverflow, Pagination } from "swiper/modules";
import axios from "axios";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";

import "./ProductSlider.css";
import { ConfigContext } from "../Context/ConfigContext";
import { useNavigate } from "react-router-dom";

export default function ProductSlider() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { ApiUrl, apiHeaderJson, createSlug } = useContext(ConfigContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${ApiUrl}apis/GetProducts`, {
          headers: apiHeaderJson,
        });
        const { success, data } = response.data;
        if (success && Array.isArray(data)) {
          // Filter products where product_signature_status === 1
          const signatureProducts = data.filter(
            (item) => item.product_signature_status === 1
          );
          // Map to component expected format
          const mapped = signatureProducts.map((item) => ({
            id: item.product_id,
            name: item.product_title,
            description: item.product_short_description || "",
            image: item?.product_signature_image_url || item.product_image_url || "",
            badge: item.product_trending_status ? "Trending" : "", // optional
          }));
          setProducts(mapped);
        } else {
          setProducts([]);
        }
      } catch (err) {
        console.error("Failed to fetch products:", err);
        setError(err.message);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [ApiUrl, apiHeaderJson]);

  if (loading) {
    return (
      <section className="product-coverflow-section">
        <div style={{ textAlign: "center", padding: "50px" }}>
          <p>Loading signature products...</p>
        </div>
      </section>
    );
  }

  if (error || products.length === 0) {
    return (
      <section className="product-coverflow-section">
        <div style={{ textAlign: "center", padding: "50px" }}>
          <p>No signature products available.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="product-coverflow-section">
      <div className="product-coverflow-header" data-aos="fade-up">
        <h2>Signature <span> Collection</span></h2>
        <p>Our most exquisite bakes, crafted to perfection</p>
      </div>

      <div className="product-coverflow-wrapper" data-aos="zoom-in-up">
        <Swiper
          modules={[Navigation, Autoplay, EffectCoverflow, Pagination]}
          effect="coverflow"
          coverflowEffect={{
            rotate: 40,
            stretch: 0,
            depth: 120,
            modifier: 1,
            slideShadows: false,
          }}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView="auto"
          loop={false}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          navigation={{
            nextEl: ".coverflow-swiper-button-next",
            prevEl: ".coverflow-swiper-button-prev",
          }}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          className="coverflowSwiper"
        >
          {products.map((product) => (
            <SwiperSlide key={product.id} className="coverflow-slide">
              <div className="coverflow-card" style={{ cursor: 'pointer' }} onClick={() => navigate(`/product/${createSlug(product.name)}-${product.id}`)} >
                <img src={product.image} alt={product.name} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Navigation Buttons */}
        <button
          className="coverflow-swiper-button-prev coverflow-arrow coverflow-arrow-prev"
          aria-label="Previous product"
        >
          ❮
        </button>
        <button
          className="coverflow-swiper-button-next coverflow-arrow coverflow-arrow-next"
          aria-label="Next product"
        >
          ❯
        </button>
      </div>
    </section>
  );
}